<div class="column-control-wrapper full-bleed-container layout-padding">
  <div class="full-bleed-row">
    <div class="container-fluid">
      <div class="row abs-no-gutters">
        <div class="remove-rl-padding col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="coupons-carousel slick-coupon-carousel-v2">
            <div class="partners-carousel-header">
              <div class="partners-carousel-title-container">
                  <h2 class="partners-carousel-title">{{partnersHeaderDisplay?.title}}</h2>
              </div>
              <div class="partners-carousel-subtitle-container">
               <p class="partners-carousel-subtitle">{{partnersHeaderDisplay?.subTitle}}</p>
             </div>
            </div>
            <div id="partners-offer-carousel">
              <div *ngFor="let offer of partnerOffers">
                <app-partnerscard [offer]="offer" [partnersInfoDefaultView]="partnersInfoDefaultView" [userInfo]="userInfo" [enableClaimOfferCTA]="enableClaimOfferCTA"></app-partnerscard>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>